/* eslint-disable no-underscore-dangle */
import axios, { AxiosRequestConfig } from 'axios'
import _ from 'lodash'
import { push } from 'connected-react-router'
import { Store } from 'redux'
import { notification } from 'antd'

import { LOGIN } from '../../routes'
import { getAccessToken, setAccessToken } from '../../utils/token'
import { SessionActions } from '../session/actions'

export function applyAxiosInterceptors(store: Store) {
  axios.interceptors.response.use(undefined, (error: any) => {
    const originalRequest = error.config
    // console.log(`${error.response.status} - ${error.request.responseURL}`)

    if (error.response.status === 401 && _.includes(_.get(error, 'request.responseURL', ''), '/login')) {
      SessionActions.clearSession()
      store.dispatch(push(LOGIN))
      return undefined
    }

    if (error.response.status === 403 && _.includes(_.get(error, 'request.responseURL', ''), '/token')) {
      store.dispatch(SessionActions.clearSession())
      store.dispatch(push(LOGIN))
      return undefined
    }

    if (error.response && error.response.status === 403) {
      notification.error({
        message: 'Autorizzazione',
        description: 'Non sei autorizzato'
      })
    }

    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true
      return axios
        .post('/users/token', {
          token: localStorage.getItem('refresh_token')
        })
        .then(res => {
          if (res && res.status === 201) {
            const token = res.data.accessToken
            setAccessToken(token)
            store.dispatch(SessionActions.restoreSession())
            axios.defaults.headers.Authorization = `Bearer ${token}`
            return axios(originalRequest)
          }
          return Promise.reject(error)
        })
    }
    notification.error({
      message: 'Login Error',
      description: 'Credenziali errate.'
    })
    store.dispatch(push(LOGIN))

    // return Error object with Promise
    return Promise.reject(error)
  })

  axios.interceptors.request.use((config: AxiosRequestConfig) => {
    const token = getAccessToken()
    if (token) {
      // eslint-disable-next-line no-param-reassign
      config.headers.Authorization = `Bearer ${token}`
    }
    // config.headers['Content-Type'] = 'application/json';
    return config
  })
}
